// extracted by mini-css-extract-plugin
export default {"item":"menu-link_item__8BR1o","selected":"menu-link_selected__rDdw-"};